import styles from "./InfoPage.module.scss"; // Імпортуємо SCSS файл для стилів
import Nav from "@/components/Header/Nav/Nav";
import Footer from "@/components/Footer/Footer";
import CookiePopupButton from "@/components/CookieBanner/CookiePopupButton.tsx";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const AGB = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Скролимо в верх сторінки
  }, []);

  return (
    <div>
      <Helmet>
        <title>AGB – HIXA – DSG Getriebe Reparatur & Wartung</title>
        <meta name="description" content="Allgemeine Geschäftsbedingungen der HIXA GmbH – DSG-Mechatronik Reparatur, Austausch und Ersatzteile." />
      </Helmet>

      <Nav />
      <h2 className={` sectionContainer ${styles.title}`}>AGB</h2>
      <div className="container sectionContainer sectionContainerWhite">
        <p className={styles.infoPageText}>
          Allgemeine Geschäftsbedingungen für den Verkauf neuer und gebrauchter
          Fahrzeugteile
        </p>
        <p className={styles.infoPageText}>Teileverkaufsbedingungen</p>
        <h2 className={styles.infoPageHeader}>I. Geltungsbereich</h2>
        <p className={styles.infoPageText}>
          1.1 Diese Allgemeinen Geschäftsbedingungen (nachfolgend “AGB”) der
          HIXA GmbH (nachfolgend “Verkäufer”), gelten für alle Verträge über die
          Lieferung von Waren, die ein Verbraucher oder Unternehmer (nachfolgend
          „Kunde“) mit dem Verkäufer hinsichtlich der vom Verkäufer in seinem
          Online-Shop dargestellten Waren abschließt. Hiermit wird der
          Einbeziehung von eigenen Bedingungen des Kunden widersprochen, es sei
          denn, es ist etwas anderes vereinbart.
        </p>
        <p className={styles.infoPageText}>
          1.2 Verbraucher im Sinne dieser AGB ist jede natürliche Person, die
          ein Rechtsgeschäft zu Zwecken abschließt, die überwiegend weder ihrer
          gewerblichen noch ihrer selbständigen beruflichen Tätigkeit
          zugerechnet werden können. Unternehmer im Sinne dieser AGB ist eine
          natürliche oder juristische Person oder eine rechtsfähige
          Personengesellschaft, die bei Abschluss eines Rechtsgeschäfts in
          Ausübung ihrer gewerblichen oder selbständigen beruflichen Tätigkeit
          handelt.
        </p>
        <h2 className={styles.infoPageHeader}>II. Zahlung</h2>
        <p className={styles.infoPageText}>
          1. Der Kaufpreis und Preise für Nebenleistungen sind bei Übergabe des
          Kaufgegenstandes und Aushändigung oder Übersendung der Rechnung zur
          Zahlung fällig.
        </p>
        <p className={styles.infoPageText}>
          2. Gegen Ansprüche des Verkäufers kann der Käufer nur dann aufrechnen,
          wenn die Gegenforderung des Käufers unbestritten ist oder ein
          rechtskräftiger Titel vorliegt. Hiervon ausgenommen sind
          Gegenforderungen des Käufers aus demselben Kaufvertrag. Ein
          Zurückbehaltungsrecht kann er nur geltend machen, soweit es auf
          Ansprüchen aus demselben Vertragsverhältnis beruht.
        </p>
        <p className={styles.infoPageText}>
          3. Zahlt der Käufer den fälligen Kaufpreis und Preise für
          Nebenleistungen nicht oder nicht vertragsgemäß, kann der Verkäufer vom
          Vertrag zurücktreten und/oder bei schuldhafter Pflichtverletzung des
          Käufers Schadensersatz statt der Leistung verlangen, wenn er dem
          Käufer erfolglos eine angemessene Frist zur Leistung bestimmt hat, es
          sei denn, die Fristsetzung ist Liefer- und Versandbedingungen.
        </p>
        <p className={styles.infoPageText}>
          4. Alle in unserem Onlineshop angegebenen Preise enthalten die
          gesetzlich festgesetzte Mehrwertsteuer.
        </p>
        <p className={styles.infoPageText}>
          5. Bitte beachten Sie bei einer Bestellung aus der Schweiz oder
          anderen Ländern, welche Einfuhrzoll erheben, dass HIXA GmbH keinen
          Einfluss auf die Höhe der Zollgebühren oder die zu entrichtenden
          Steuern Ihres Landes hat. In diesem Fall informieren Sie sich bitte
          über die für Sie anfallenden Kosten einer Bestellung, welche erst bei
          der Einfuhr der Ware in Ihr Land erhoben werden. Diese Gebühren werden
          NICHT von HIXA GmbH erhoben und sind auch NICHT bereits in den
          Versandgebühren enthalten.
        </p>
        <p className={styles.infoPageText}>
          Der Kunde kann zwischen folgenden Zahlarten wählen: Rechnung, Sofort
          Überweisung, Nachnahme, PayPal oder Kreditkarte.
        </p>
        <h2 className={styles.infoPageHeader}>III. Vertragsschluss</h2>
        <p className={styles.infoPageText}>
          1. Die im Online-Shop des Verkäufers enthaltenen Produktbeschreibungen
          stellen keine verbindlichen Angebote seitens des Verkäufers dar,
          sondern dienen zur Abgabe eines verbindlichen Angebots durch den
          Kunden.
        </p>
        <p className={styles.infoPageText}>
          2. Der Kunde kann das Angebot über das in den Online-Shop des
          Verkäufers integrierte Online-Bestellformular abgeben. Dabei gibt der
          Kunde, nachdem er die ausgewählten Waren in den virtuellen Warenkorb
          gelegt und den elektronischen Bestellprozess durchlaufen hat, durch
          Klicken des den Bestellvorgang abschließenden Buttons ein rechtlich
          verbindliches Vertragsangebot in Bezug auf die im Warenkorb
          enthaltenen Waren ab.
        </p>
        <p className={styles.infoPageText}>
          3. Der Verkäufer kann das Angebot des Kunden innerhalb von fünf Tagen
          annehmen, indem er dem Kunden eine schriftliche Auftragsbestätigung
          oder eine Auftragsbestätigung in Textform (Fax oder E-Mail)
          übermittelt, wobei insoweit der Zugang der Auftragsbestätigung beim
          Kunden maßgeblich ist, oder indem er dem Kunden die bestellte Ware
          liefert, wobei insoweit der Zugang der Ware beim Kunden maßgeblich
          ist, oder indem er den Kunden nach Abgabe von dessen Bestellung zur
          Zahlung auffordert.
        </p>
        <p className={styles.infoPageText}>
          Liegen mehrere der vorgenannten Alternativen vor, kommt der Vertrag in
          dem Zeitpunkt zustande, in dem eine der vorgenannten Alternativen
          zuerst eintritt. Die Frist zur Annahme des Angebots beginnt am Tag
          nach der Absendung des Angebots durch den Kunden zu laufen und endet
          mit dem Ablauf des fünften Tages, welcher auf die Absendung des
          Angebots folgt. Nimmt der Verkäufer das Angebot des Kunden innerhalb
          vorgenannter Frist nicht an, so gilt dies als Ablehnung des Angebots
          mit der Folge, dass der Kunde nicht mehr an seine Willenserklärung
          gebunden ist.
        </p>
        <p className={styles.infoPageText}>
          4. Bei Auswahl der Zahlungsart „PayPal“ erfolgt die Zahlungsabwicklung
          über den Zahlungsdienstleister PayPal (Europe) S.à r.l. et Cie,
          S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg (im Folgenden:
          „PayPal“), unter Geltung der PayPal-Nutzungsbedingungen, einsehbar
          unter https://www.paypal.com/de/webapps/mpp/ua/useragreement-full oder
          – falls der Kunde nicht über ein PayPal-Konto verfügt – unter Geltung
          der Bedingungen für Zahlungen ohne PayPal-Konto, einsehbar unter
          https://www.paypal.com/de/webapps/mpp/ua/privacywax-full. Wählt der
          Kunde im Rahmen des Online-Bestellvorgangs „PayPal Express“ als
          Zahlungsart aus, erteilt er durch Klicken des den Bestellvorgang
          abschließenden Buttons zugleich auch einen Zahlungsauftrag an PayPal.
          Für diesen Fall erklärt der Verkäufer schon jetzt die Annahme des
          Angebots des Kunden in dem Zeitpunkt, in dem der Kunde durch Klicken
          des den Bestellvorgang abschließenden Buttons den Zahlungsvorgang
          auslöst.
        </p>
        <p className={styles.infoPageText}>
          5. Bei der Abgabe eines Angebots über das Online-Bestellformular des
          Verkäufers wird der Vertragstext vom Verkäufer gespeichert und dem
          Kunden nach Absendung seiner Bestellung nebst den vorliegenden AGB in
          Textform (z. B. E-Mail, Fax oder Brief) zugeschickt. Zusätzlich wird
          der Vertragstext auf der Internetseite des Verkäufers archiviert und
          kann vom Kunden über sein passwortgeschütztes Kundenkonto unter Angabe
          der entsprechenden Login-Daten kostenlos abgerufen werden, sofern der
          Kunde vor Absendung seiner Bestellung ein Kundenkonto im Online-Shop
          des Verkäufers angelegt hat.
        </p>
        <p className={styles.infoPageText}>
          6. Vor verbindlicher Abgabe der Bestellung über das
          Online-Bestellformular des Verkäufers kann der Kunde mögliche
          Eingabefehler durch aufmerksames Lesen der auf dem Bildschirm
          dargestellten Informationen erkennen. Ein wirksames technisches Mittel
          zur besseren Erkennung von Eingabefehlern kann dabei die
          Vergrößerungsfunktion des Browsers sein, mit deren Hilfe die
          Darstellung auf dem Bildschirm vergrößert wird. Seine Eingaben kann
          der Kunde im Rahmen des elektronischen Bestellprozesses so lange über
          die üblichen Tastatur- und Mausfunktionen korrigieren, bis er den
          Bestellvorgang abschließenden Button anklickt.
        </p>
        <p className={styles.infoPageText}>
          7. Für den Vertragsschluss steht ausschließlich die deutsche Sprache
          zur Verfügung.
        </p>
        <p className={styles.infoPageText}>
          8. Die Bestellabwicklung und Kontaktaufnahme finden in der Regel per
          E-Mail und automatisierter Bestellabwicklung statt. Der Kunde hat
          sicherzustellen, dass die von ihm zur Bestellabwicklung angegebene
          E-Mail-Adresse zutreffend ist, so dass unter dieser Adresse die vom
          Verkäufer versandten E-Mails empfangen werden können. Insbesondere hat
          der Kunde bei dem Einsatz von SPAM-Filtern sicherzustellen, dass alle
          vom Verkäufer oder von diesem mit der Bestellabwicklung beauftragten
          Dritten versandten E-Mails zugestellt werden können.
        </p>
        <h2 className={styles.infoPageHeader}>
          IV. Liefer- und Versandbedingungen
        </h2>
        <p className={styles.infoPageText}>
          1. Die Lieferung von Waren erfolgt auf dem Versandweg an die vom
          Kunden angegebene Lieferanschrift, sofern nichts anderes vereinbart
          ist.
        </p>
        <p className={styles.infoPageText}>
          2. Sendet das Transportunternehmen die versandte Ware an den Verkäufer
          zurück, da eine Zustellung beim Kunden nicht möglich war, trägt der
          Kunde die Kosten für den erfolglosen Versand. Dies gilt nicht, wenn
          der Kunde sein Widerrufsrecht wirksam ausübt, wenn er den Umstand, der
          zur Unmöglichkeit der Zustellung geführt hat, nicht zu vertreten hat
          oder wenn er vorübergehend an der Annahme der angebotenen Leistung
          verhindert war, es sei denn, dass der Verkäufer ihm die Leistung eine
          angemessene Zeit vorher angekündigt hatte.
        </p>
        <p className={styles.infoPageText}>
          3. Handelt der Kunde als Unternehmer, geht die Gefahr des zufälligen
          Untergangs und der zufälligen Verschlechterung der verkauften Ware auf
          den Kunden über, sobald der Verkäufer die Sache dem Spediteur, dem
          Frachtführer oder der sonst zur Ausführung der Versendung bestimmten
          Person oder Anstalt ausgeliefert hat. Handelt der Kunde als
          Verbraucher, geht die Gefahr des zufälligen Untergangs und der
          zufälligen Verschlechterung der verkauften Ware grundsätzlich erst mit
          Übergabe der Ware an den Kunden oder eine empfangsberechtigte Person
          über. Abweichend hiervon geht die Gefahr des zufälligen Untergangs und
          der zufälligen Verschlechterung der verkauften Ware auch bei
          Verbrauchern bereits auf den Kunden über, sobald der Verkäufer die
          Sache dem Spediteur, dem Frachtführer oder der sonst zur Ausführung
          der Versendung bestimmten Person oder Anstalt ausgeliefert hat, wenn
          der Kunde den Spediteur, den Frachtführer oder die sonst zur
          Ausführung der Versendung bestimmte Person oder Anstalt mit der
          Ausführung beauftragt und der Verkäufer dem Kunden diese Person oder
          Anstalt zuvor nicht benannt hat.
        </p>
        <p className={styles.infoPageText}>
          4. Der Verkäufer behält sich das Recht vor, im Falle nicht richtiger
          oder nicht ordnungsgemäßer Selbstbelieferung vom Vertrag
          zurückzutreten. Dies gilt nur für den Fall, dass die Nichtlieferung
          nicht vom Verkäufer zu vertreten ist und dieser mit der gebotenen
          Sorgfalt ein konkretes Deckungsgeschäft mit dem Zulieferer
          abgeschlossen hat. Der Verkäufer wird alle zumutbaren Anstrengungen
          unternehmen, um die Ware zu beschaffen. Im Falle der
          Nichtverfügbarkeit oder der nur teilweisen Verfügbarkeit der Ware wird
          der Kunde unverzüglich informiert und die Gegenleistung unverzüglich
          erstattet.
        </p>
        <p className={styles.infoPageText}>
          5. Selbstabholung ist aus logistischen Gründen nicht möglich
        </p>
        <h2 className={styles.infoPageHeader}>V. Eigentumsvorbehalt</h2>
        <p className={styles.infoPageText}>
          1. Gegenüber Verbrauchern behält sich der Verkäufer bis zur
          vollständigen Bezahlung des geschuldeten Kaufpreises das Eigentum an
          der gelieferten Ware vor.
        </p>
        <p className={styles.infoPageText}>
          2. Gegenüber Unternehmern behält sich der Verkäufer bis zur
          vollständigen Begleichung aller Forderungen aus einer laufenden
          Geschäftsbeziehung das Eigentum an der gelieferten Ware vor.
        </p>
        <p className={styles.infoPageText}>
          3. Handelt der Kunde als Unternehmer, so ist er zur Weiterveräußerung
          der Vorbehaltsware im ordnungsgemäßen Geschäftsbetrieb berechtigt.
          Sämtliche hieraus entstehenden Forderungen gegen Dritte tritt der
          Kunde in Höhe des jeweiligen Rechnungswertes (einschließlich
          Umsatzsteuer) im Voraus an den Verkäufer ab. Diese Abtretung gilt
          unabhängig davon, ob die Vorbehaltsware ohne oder nach Verarbeitung
          weiterverkauft worden ist. Der Kunde bleibt zur Einziehung der
          Forderungen auch nach der Abtretung ermächtigt. Die Befugnis des
          Verkäufers, die Forderungen selbst einzuziehen, bleibt davon
          unberührt. Der Verkäufer wird jedoch die Forderungen nicht einziehen,
          solange der Kunde seinen Zahlungsverpflichtungen dem Verkäufer
          gegenüber nachkommt, nicht in Zahlungsverzug gerät und kein Antrag auf
          Eröffnung eines Insolvenzverfahrens gestellt ist.
        </p>
        <h2 className={styles.infoPageHeader}>
          VI. Mängelhaftung (Gewährleistung)
        </h2>
        <p className={styles.infoPageText}>
          Ist die Kaufsache mangelhaft, gelten die Vorschriften der gesetzlichen
          Mängelhaftung. Hiervon abweichend gilt:
        </p>
        <p className={styles.infoPageText}>1. Für Unternehmer:</p>
        <p className={styles.infoPageText}>
          begründet ein unwesentlicher Mangel grundsätzlich keine
          Mängelansprüche;
        </p>
        <p className={styles.infoPageText}>
          hat der Verkäufer die Wahl der Art der Nacherfüllung;
        </p>
        <p className={styles.infoPageText}>
          beträgt bei neuen Waren die Verjährungsfrist für Mängel ein Jahr ab
          Gefahrübergang;
        </p>
        <p className={styles.infoPageText}>
          sind bei gebrauchten Waren die Rechte und Ansprüche wegen Mängeln
          grundsätzlich ausgeschlossen;
        </p>
        <p className={styles.infoPageText}>
          beginnt die Verjährung nicht erneut, wenn im Rahmen der Mängelhaftung
          eine Ersatzlieferung erfolgt.
        </p>
        <p className={styles.infoPageText}>
          2. Für Verbraucher beträgt die Verjährungsfrist für Mängelansprüche
          bei gebrauchten Waren halb Jahr ab Ablieferung der Ware an den Kunden,
          mit der Einschränkung der nachfolgenden Ziffer.
        </p>
        <p className={styles.infoPageText}>
          3. Die vorstehend geregelten Haftungsbeschränkungen und
          Verjährungsfristverkürzungen gelten nicht für Sachen, die nicht
          entsprechend ihrer üblichen Verwendungsweise für ein verwendet worden
          sind und dessen Mangelhaftigkeit verursacht haben, für Schäden aus der
          Verletzung des Lebens, des Körpers oder der Gesundheit, die auf einer
          vorsätzlichen oder fahrlässigen Pflichtverletzung des Verkäufers oder
          einer vorsätzlichen oder fahrlässigen Pflichtverletzung eines
          gesetzlichen Vertreters oder Erfüllungsgehilfen des Verkäufers
          beruhen,
        </p>
        <p className={styles.infoPageText}>
          für sonstige Schäden, die auf einer vorsätzlichen oder grob
          fahrlässigen Pflichtverletzung des Verkäufers oder auf einer
          vorsätzlichen oder grob fahrlässigen Pflichtverletzung eines
          gesetzlichen Vertreters oder Erfüllungsgehilfen des Verwenders
          beruhen, sowie
        </p>
        <p className={styles.infoPageText}>
          für den Fall, dass der Verkäufer den Mangel arglistig verschwiegen
          hat.
        </p>
        <p className={styles.infoPageText}>
          4. Darüber hinaus gilt für Unternehmer, dass die gesetzlichen
          Verjährungsfristen für den Rückgriffsanspruch nach § 478 BGB unberührt
          bleiben.
        </p>
        <p className={styles.infoPageText}>
          5. Handelt der Kunde als Kaufmann i.S.d. § 1 HGB, trifft ihn die
          kaufmännische Untersuchungs- und Rügepflicht gemäß § 377 HGB.
          Unterlässt der Kunde die dort geregelten Anzeigepflichten, gilt die
          Ware als genehmigt.
        </p>
        <p className={styles.infoPageText}>
          6. Handelt der Kunde als Verbraucher, so wird er gebeten, angelieferte
          Waren mit offensichtlichen Transportschäden bei dem Zusteller zu
          reklamieren und den Verkäufer hiervon in Kenntnis zu setzen. Kommt der
          Kunde dem nicht nach, hat dies keinerlei Auswirkungen auf seine
          gesetzlichen oder vertraglichen Mängelansprüche.
        </p>
        <h2 className={styles.infoPageHeader}>VII. Haftung für Sachmängel</h2>
        <p className={styles.infoPageText}>
          1. Ansprüche des Käufers wegen Sachmängeln verjähren entsprechend den
          gesetzlichen Bestimmungen in zwei Jahren ab Ablieferung des
          Kaufgegenstandes. Hiervon abweichend gilt eine Verjährungsfrist von
          einem Jahr, wenn der Käufer eine juristische Person des öffentlichen
          Rechts, ein öffentlich-rechtliches Sondervermögen oder ein Unternehmer
          ist, der bei Abschluss des Vertrages in Ausübung seiner gewerblichen
          oder selbständigen beruflichen Tätigkeit handelt.
        </p>
        <p className={styles.infoPageText}>
          2. Die Verjährungsverkürzung in Ziffer 1, Satz 2 gilt nicht für
          Schäden, die auf einer grob fahrlässigen oder vorsätzlichen Verletzung
          von Pflichten des Verkäufers, seines gesetzlichen Vertreters oder
          seines Erfüllungsgehilfen beruhen sowie bei Verletzung von Leben,
          Körper oder Gesundheit.
        </p>
        <p className={styles.infoPageText}>
          3. Hat der Verkäufer aufgrund der gesetzlichen Bestimmungen für einen
          Schaden aufzukommen, der leicht fahrlässig verursacht wurde, so haftet
          der Verkäufer beschränkt: Die Haftung besteht nur bei Verletzung
          vertragswesentlicher Pflichten, etwa solcher, die der Kaufvertrag dem
          Verkäufer nach seinem Inhalt und Zweck gerade auferlegen will oder
          deren Erfüllung die ordnungsgemäße Durchführung des Kaufvertrages
          überhaupt erst ermöglicht und auf deren Einhaltung der Käufer
          regelmäßig vertraut und vertrauen darf. Diese Haftung ist auf den bei
          Vertragsabschluss vorhersehbaren typischen Schaden begrenzt. Für die
          vorgenannte Haftungsbegrenzung und den vorgenannten Haftungsausschluss
          gilt Ziffer 2 dieses Abschnitts entsprechend.
        </p>
        <p className={styles.infoPageText}>
          4. Unabhängig von einem Verschulden des Verkäufers bleibt eine etwaige
          Haftung des Verkäufers bei arglistigem Verschweigen eines Mangels, aus
          der Übernahme einer Garantie oder eines Beschaffungsrisikos und nach
          dem Produkthaftungsgesetz unberührt.
        </p>
        <p className={styles.infoPageText}>
          5. Soll eine Mängelbeseitigung durchgeführt werden, gilt folgendes:
        </p>
        <p className={styles.infoPageText}>
          a Ansprüche auf Mängelbeseitigung kann der, vom Hersteller/Importeur
          für die Betreuung des Kaufgegenstandes anerkannten Betrieben geltend
          machen; im letzteren Fall hat der Käufer den Verkäufer hiervon
          unverzüglich zu unterrichten, wenn die erste Mängelbeseitigung
          erfolglos war. Bei mündlichen Anzeigen von Ansprüchen ist dem Käufer
          eine schriftliche Bestätigung über den Eingang der Anzeige
          auszuhändigen.
        </p>
        <p className={styles.infoPageText}>
          b Wird der Kaufgegenstand wegen eines Sachmangels betriebsunfähig, hat
          sich der Käufer an den dem Ort des betriebsunfähigen Kaufgegenstandes
          nächstgelegenen, vom Hersteller/Importeur für die Betreuung des
          Kaufgegenstandes anerkannten dienstbereiten Betrieb zu wenden.
        </p>
        <p className={styles.infoPageText}>
          c Für die zur Mängelbeseitigung eingebauten Teile kann der Käufer bis
          zum Ablauf der Verjährungsfrist des Kaufgegenstandes
          Sachmängelansprüche aufgrund des Kaufvertrages geltend machen.
        </p>
        <p className={styles.infoPageText}>
          d Ersetzte Teile werden Eigentum des Verkäufers.
        </p>
        <p className={styles.infoPageText}>
          6. Durch Eigentumswechsel am Kaufgegenstand werden
          Mängelbeseitigungsansprüche nicht berührt.
        </p>
        <h2 className={styles.infoPageHeader}>VIII. Gerichtsstand</h2>
        <p className={styles.infoPageText}>
          Für sämtliche gegenwärtigen und zukünftigen Ansprüche aus der
          Geschäftsverbindung mit Kaufleuten einschließlich Wechselforderungen
          ist ausschließlicher Gerichtsstand der Sitz des Verkäufers.
        </p>
        <h2 className={styles.infoPageHeader}>GEWÄHRLEISTUNG</h2>
        <p className="secure-policy__date">
          1. Dem Kunden stehen (vorbehaltlich der Regelung für Unternehmer in
          Ziff. 13.) die gesetzlichen Gewährleistungsrechte zu.
        </p>
        <p className={styles.infoPageText}>
          2. Keine Gewährleistung wird übernommen für Schäden, die entstanden
          sind aus unsachgemäßer oder ungeeigneter Verwendung, fehlerhafter
          Inbetriebnahme oder Montage, natürliche Abnutzung, nachlässige oder
          fehlerhafte Verwendung, Nichtbeachtung der Wartungs- oder
          Betriebsanleitung sowie unsachgemäße Instandsetzungsarbeiten oder
          Änderungen durch den Kunden oder Dritte.
        </p>
        <p className={styles.infoPageText}>
          3. Gewährleistung für Unternehmer: Ist der Kunde Unternehmer im Sinne
          des § 14 BGB gilt für die Gewährleistungsansprüche des Kunden
          weiterhin Folgendes als vereinbart (Unternehmer ist eine natürliche
          oder juristische Person oder eine rechtsfähige Personengesellschaft,
          die bei Abschluss der Bestellung in Ausübung ihrer gewerblichen oder
          selbständigen beruflichen Tätigkeit handelt):
        </p>
        <p className={styles.infoPageText}>
          3.1. Soweit HIXA GmbH wegen eines Mangels Gewähr durch Nacherfüllung
          zu leisten hat, liegt die Wahl, ob die Nacherfüllung durch
          Nachbesserung oder Ersatzlieferung einer mangelfreien Sache erfolgt,
          bei HIXA GmbH .
        </p>
        <p className={styles.infoPageText}>
          3.2. Offensichtliche Mängel müssen gegenüber HIXA GmbH unverzüglich,
          spätestens innerhalb von 14 Kalendertagen nach Lieferung der Ware in
          Textform E-Mai angezeigt werden, verdeckte Mängel sind ebenfalls
          unverzüglich, spätestens innerhalb von 14 Kalendertagen nach deren
          bekannt werden in E-Mail anzuzeigen. Erfolgt die Mängelanzeige nicht
          fristgerecht, sind die Gewährleistungsrechte des Kunden bezogen auf
          den nicht rechtzeitig angezeigten Mangel ausgeschlossen.
          <span id="GARANTIE"></span>&nbsp;Das gilt jedoch nicht, soweit HIXA
          GmbH den Mangel arglistig verschwiegen und/oder eine entsprechende
          Garantie übernommen hat.
        </p>
        <p className={styles.infoPageText}>
          3.3. Gewährleistungsansprüche des Kunden verjähren innerhalb eines
          Jahres nach Ablieferung der Kaufsache an den Kunden, es sei denn, HIXA
          GmbH hat den Mangel zu vertreten.
        </p>
        <h2 className={styles.infoPageHeader}>GARANTIE</h2>
        <p className="secure-policy__date">
          © Copyright | Alle Rechte vorbehalten.
        </p>
        <p className={styles.infoPageText}>
          Auf Verlangen des Gesetzgebers Informieren wir Sie über unsere
          Garantiebedingungen welche die gesetzlichen Regelungen nicht
          beeinträchtigt.
        </p>
        <p className={styles.infoPageText}>
          Inhalt der Garantie: Die Garantie erstreckt sich ausschließlich auf
          die von der Firma HIXA GmbH Inh. Anna Likhnenko und Heorhii Shapovalov
          ausgeführten Arbeiten. Bei ausgebauten Steuergeräten die uns zugesandt
          werden, sind die Montagekosten nicht Bestandteil unserer Garantie und
          können nicht erstattet werden. Wurde das betreffende Steuergerät in
          unserem Hause für den Kunden montiert, gilt die Garantie auch für den
          Aus -und Einbau. Kosten für Überprüfungen durch Fremdfirmen werden
          nicht erstattet. Die Garantie für Austausch-Geräte umfasst
          ausschließlich die in der Rechnung genannten Baugruppen/Bauteile. Die
          Garantie beschränkt sich auf die in unserem Angebot genannten Fehler
          die auf das Kunden – Fahrzeug zutreffen. Das Fahrzeug-Modell, sowie
          das Baujahr und die Gerätenummer ist vom Kunden selbst zu überprüfen.
          (Siehe Artikelbeschreibung auf unserer Homepage, bei eBay oder bei
          eBay Kleinanzeigen)
        </p>
        <p className={styles.infoPageText}>
          Geltungsdauer: Die Garantiezeit beginnt ab Rechnungsdatum und beträgt,
          je nach Dienstleistung, ein Jahr bei ungeöffneten Geräten. Die
          Garantiedauer findet sich in der Artikelbeschreibung. Wir reparieren
          keine Steuergeräte oder andere Komponenten, wenn diese nicht dem
          Originalzustand entsprechen oder geöffnet wurden. Allerdings führen
          wir auf ausdrücklichen Kundenwunsch bei Letzteren eine Reparatur nach
          bestem Wissen aus. Dazu bedarf es der Zustimmung des Auftraggebers. In
          einem solchen Falle behalten wir uns vor, eine Garantie auf das Gerät,
          dessen Einbau und einwandfreie Funktionsweise, nicht zu gewähren oder
          einzuschränken
        </p>
        <p className={styles.infoPageText}>
          Geltungsbereich: Unsere Garantieleistung ist allgemein gültig in
          Deutschland und der EU
        </p>
        <p className={styles.infoPageText}>Garantiegeber:</p>
        <p className={styles.infoPageText}>Anna Likhnenko</p>
        <p className={styles.infoPageText}>HIXA GmbH </p>
        <p className={styles.infoPageText}>Neukirchstraße 74, 13089 Berlin</p>
        <p id="WIDERRUFSRECHT" className={styles.infoPageText}>
          Garantiefall: Die Mängelrüge ist schriftlich oder mündlich
          vorzutragen. Um vorab beurteilen zu können, ob es sich um eine
          Garantieleistung handelt, muss das entsprechende Bauteil noch einmal
          kundenseitig ausgelesen werden und uns der Fehlercode inkl.
          Rechnungskopie übermittelt werden. Nach Zusage zur Prüfung des
          Garantiefalls, kann uns das Gerät zugestellt und die Garantie-Leistung
          in Anspruch genommen werden.
        </p>
        <h2 className={styles.infoPageHeader}>Rückerstattungen</h2>
        <p className={styles.infoPageText}>
          HIXA GmbH gewährt keine Rückerstattungen für Reparaturaufträge und
          Datenübertragung.
        </p>
        <p className={styles.infoPageText}>Stornierung</p>
        <p className={styles.infoPageText}>
          Nach der Annahme eines Reparaturauftrags leitet HIXA GmbH die
          Reparatur ein. Danach können Reparaturaufträge nicht mehr storniert
          werden. Sie sind auch nicht berechtigt, vom Vertrag zurückzutreten.
        </p>
        <p className={styles.infoPageText}>Achtung!!!</p>
        <p className={styles.infoPageText}>
          Der Käufer trägt die mit der Installation und Anpassung der
          Mechatronik verbundenen Risiken. Im Falle einer teilweisen oder
          vollständigen Fehlfunktion des Bauteils erfolgt ein kostenloser
          Austausch des Geräts auf unbestrittenem Grund. Der Käufer ist selbst
          für die Kosten und Konsequenzen im Zusammenhang mit Defekten am
          Bauteil verantwortlich und verzichtet auf jegliche Ansprüche.
        </p>
        <h2 className={styles.infoPageHeader}>WIDERRUFSRECHT</h2>
        <p className="secure-policy__date">Aktualisiert: Oktober 2023</p>
        <p className={styles.infoPageText}>
          A. Widerrufsrecht für Verbraucher bei Warenlieferung
        </p>
        <p className={styles.infoPageText}>
          (Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu
          Zwecken abschließt, die überwiegend weder ihrer gewerblichen noch
          ihrer selbstständigen beruflichen Tätigkeit zugerechnet werden
          können.)
        </p>
        <p className={styles.infoPageText}>Widerrufsbelehrung</p>
        <p className={styles.infoPageText}>A.1. Widerrufsrecht</p>
        <p className={styles.infoPageText}>
          Sie haben das Recht, binnen 14 Tagen ohne Angabe von Gründen diesen
          Vertrag zu widerrufen.
        </p>
        <p className={styles.infoPageText}>
          Die Widerrufsfrist beträgt 14 Tage ab dem Tag,
        </p>
        <p className={styles.infoPageText}>
          – an dem Sie oder ein von Ihnen benannter Dritter, der nicht der
          Beförderer ist, die Waren in Besitz genommen haben bzw. hat, sofern
          Sie eine oder mehrere Waren im Rahmen einer einheitlichen Bestellung
          bestellt haben und diese einheitlich geliefert wird bzw. werden;
        </p>
        <p className={styles.infoPageText}>
          – an dem Sie oder ein von Ihnen benannter Dritter, der nicht der
          Beförderer ist, die letzte Ware in Besitz genommen haben bzw. hat,
          sofern Sie mehrere Waren im Rahmen einer einheitlichen Bestellung
          bestellt haben und diese getrennt geliefert werden;
        </p>
        <p className={styles.infoPageText}>
          – an dem Sie oder ein von Ihnen benannter Dritter, der nicht der
          Beförderer ist, die letzte Teilsendung oder das letzte Stück in Besitz
          genommen haben bzw. hat, sofern Sie eine Ware bestellt haben, die in
          mehreren Teilsendungen oder Stücken geliefert wird;
        </p>
        <p className={styles.infoPageText}>
          Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (HIXA GmbH ,
          Geschäftsführerin Anna Likhnenko, HIXA GmbH Neukirchstraße 74, 13089
          Berlin, Telefonnummer: +49 30 520 151 91, E-Mail-Adresse:
          kunden@hixa.eu) mittels einer eindeutigen Erklärung (z.B. ein mit der
          Post versandter Brief, Telefax oder E-Mail) über Ihren Entschluss,
          diesen Vertrag zu widerrufen, informieren. Sie können dafür das
          beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht
          vorgeschrieben ist.
        </p>
        <p className={styles.infoPageText}>
          Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung
          über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist
          absenden.
        </p>
        <p className={styles.infoPageText}>A.2. Folgen des Widerrufs</p>
        <p className={styles.infoPageText}>
          Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen,
          die wir von Ihnen erhalten haben, ausschließlich der Lieferkosten,
          unverzüglich und spätestens binnen 14 Tagen ab dem Tag zurückzuzahlen,
          an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns
          eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe
          Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt
          haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes
          vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung
          Entgelte berechnet.
        </p>
        <p className={styles.infoPageText}>
          Wir können die Rückzahlung verweigern, bis wir die Waren wieder
          zurückerhalten haben oder bis Sie den Nachweis erbracht haben, dass
          Sie die Waren zurückgesandt haben, je nachdem, welches der frühere
          Zeitpunkt ist.
        </p>
        <p className={styles.infoPageText}>
          Sie haben die Waren unverzüglich und in jedem Fall spätestens binnen
          14 Tagen ab dem Tag, an dem Sie uns über den Widerruf dieses Vertrags
          unterrichten, an uns zurückzusenden oder zu übergeben. Die Frist ist
          gewahrt, wenn Sie die Waren vor Ablauf der Frist von 14 Tagen
          absenden.
        </p>
        <p className={styles.infoPageText}>
          Sie tragen die unmittelbaren Kosten der Rücksendung der Waren.
        </p>
        <p className={styles.infoPageText}>
          Sie müssen für einen etwaigen Wertverlust der Waren nur aufkommen,
          wenn dieser Wertverlust auf einen zur Prüfung der Beschaffenheit,
          Eigenschaften und Funktionsweise der Waren nicht notwendigen Umgang
          mit ihnen zurückzuführen ist.
        </p>
        <p className={styles.infoPageText}>
          A.3. Ausschluss- bzw. Erlöschensgründe
        </p>
        <p className={styles.infoPageText}>
          Das Widerrufsrecht besteht nicht bei Verträgen zur Lieferung von
          Waren, die nicht vorgefertigt sind und für deren Herstellung eine
          individuelle Auswahl oder Bestimmung durch den Verbraucher maßgeblich
          ist oder die eindeutig auf die persönlichen Bedürfnisse des
          Verbrauchers zugeschnitten sind.
        </p>
        <p className={styles.infoPageText}>
          B. Widerrufsrecht für Verbraucher bei Dienstleistungen
        </p>
        <p className={styles.infoPageText}>
          (Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu
          Zwecken abschließt, die überwiegend weder ihrer gewerblichen noch
          ihrer selbstständigen beruflichen Tätigkeit zugerechnet werden
          können.)
        </p>
        <p className={styles.infoPageText}>Widerrufsbelehrung</p>
        <p className={styles.infoPageText}>B.1. Widerrufsrecht</p>
        <p className={styles.infoPageText}>
          Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen
          diesen Vertrag zu widerrufen.
        </p>
        <p className={styles.infoPageText}>
          Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des
          Vertragsabschlusses.
        </p>
        <p className={styles.infoPageText}>
          Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (HIXA GmbH ,
          Geschäftsführerin Anna Likhnenko, HIXA GmbH Neukirchstraße 74, 13089
          Berlin, Telefonnummer: +49 30 520 151 91, E-Mail-Adresse:
          kunden@hixa.eu) mittels einer eindeutigen Erklärung (z.B. ein mit der
          Post versandter Brief, Telefax oder E-Mail) über Ihren Entschluss,
          diesen Vertrag zu widerrufen, informieren. Sie können dafür das
          beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht
          vorgeschrieben ist.
        </p>
        <p className={styles.infoPageText}>
          Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung
          über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist
          absenden.
        </p>
        <p className={styles.infoPageText}>B.2. Folgen des Widerrufs</p>
        <p className={styles.infoPageText}>
          Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen,
          die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit
          Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie
          eine andere Art der Lieferung als die von uns angebotene, günstigste
          Standardlieferung gewählt haben), unverzüglich und spätestens binnen
          vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über
          Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese
          Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der
          ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen
          wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden
          Ihnen wegen dieser Rückzahlung Entgelte berechnet.
        </p>
        <p className={styles.infoPageText}>
          B.3. Ausschluss- bzw. Erlöschensgründe
        </p>
        <p className={styles.infoPageText}>
          Das Widerrufsrecht erlischt bei Verträgen zur Erbringung von
          Dienstleistungen, wenn der Unternehmer die Dienstleistung vollständig
          erbracht hat und mit der Ausführung der Dienstleistung erst begonnen
          hat, nachdem der Verbraucher dazu seine ausdrückliche Zustimmung
          gegeben hat und gleichzeitig seine Kenntnis davon bestätigt hat, dass
          er sein Widerrufsrecht bei vollständiger Vertragserfüllung durch den
          Unternehmer verliert.
        </p>
        <p className={styles.infoPageText}>C. Muster-Widerrufsformular</p>
        <p className={styles.infoPageText}>
          (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses
          Formular aus und senden es zurück.)
        </p>
        <p className={styles.infoPageText}>
          - An HIXA GmbH , Neukirchstraße 74, 13089 Berlin, Telefonnummer: +49
          30 520 151 91, E-Mail-Adresse: kunden@hixa.eu:
        </p>
        <p className={styles.infoPageText}>
          - Hiermit widerrufe(n) ich / wir (*) den von mir / uns (*)
          abgeschlossenen Vertrag über den Kauf der folgenden Waren (*) /
          Erbringung der folgenden Dienstleistung (*)
        </p>
        <p className={styles.infoPageText}>
          - Bestellt am (*) / erhalten am (*)
        </p>
        <p className={styles.infoPageText}>- Name des / der Verbraucher(s)</p>
        <p className={styles.infoPageText}>
          - Anschrift des / der Verbraucher(s)
        </p>
        <p className={styles.infoPageText}>
          - Unterschrift des / der Verbraucher(s) (nur bei Mitteilung auf
          Papier)
        </p>
        <p className={styles.infoPageText}>- Datum</p>
        <p className={styles.infoPageText}>(*) Unzutreffendes streichen.</p>
        <p className={styles.infoPageText}>
          (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses
          Formular aus und senden es zurück.)
        </p>
        <p className={styles.infoPageText}>D. Rückerstattungen</p>
        <p className={styles.infoPageText}>
          HIXA GmbH gewährt keine Rückerstattungen für Reparaturaufträge und
          Datenübertragung.
        </p>
        <p className={styles.infoPageText}>E. Stornierung</p>
        <p className={styles.infoPageText}>
          Nach der Annahme eines Reparaturauftrags leitet HIXA GmbH die
          Reparatur ein. Danach können Reparaturaufträge nicht mehr storniert
          werden. Sie sind auch nicht berechtigt, vom Vertrag zurückzutreten.
        </p>
        <p className={styles.infoPageText}>
          - Hiermit widerrufe(n) ich / wir (*) den von mir / uns (*)
          abgeschlossenen Vertrag über den Kauf der folgenden Waren (*) /
        </p>
        <h2 className={styles.infoPageHeader}>
          Ausschluss des Rückgaberechts für bestimmte Waren
        </h2>
        <p className={styles.infoPageText}>
          Bestimmte Waren sind aufgrund ihrer Beschaffenheit vom Widerrufsrecht
          ausgeschlossen. Dazu gehören insbesondere:
        </p>
        <p className={styles.infoPageText}>
          1.&nbsp;<strong>Sonderaufträge:</strong>&nbsp;Waren, die speziell nach
          den individuellen Vorgaben des Kunden angefertigt, angepasst oder auf
          persönliche Bedürfnisse zugeschnitten wurden. Diese beinhalten
          insbesondere Teile, die nach Maß, individuellen technischen
          Anforderungen oder persönlichen Wünschen des Kunden gefertigt wurden.
        </p>
        <p className={styles.infoPageText}>
          2.&nbsp;<strong>Elektronische Komponenten:</strong>&nbsp;Elektronische
          Bauteile und Steuergeräte, die nach der Öffnung oder Montage nicht
          mehr im originalen Zustand sind, unterliegen ebenfalls nicht dem
          Widerrufsrecht. Dies gilt insbesondere dann, wenn das Produkt bereits
          in ein Fahrzeug eingebaut wurde oder eine individuelle Anpassung
          erfordert.
        </p>
        <p className={styles.infoPageText}>
          2a.&nbsp;<strong>Individuell programmierte Mechatronik:</strong>
          &nbsp;Mechatronik-Steuergeräte, die individuell für den Kunden
          programmiert oder angepasst werden, sind vom Rückgaberecht und
          Umtausch vollständig ausgeschlossen (§ 312g Abs. 2 Nr. 1 BGB). Im
          Garantiefall verpflichtet sich HIXA GmbH nicht zur Fehleranalyse am
          Fahrzeug des Kunden. Stattdessen kann dem Kunden angeboten werden, das
          gelieferte Teil in ein firmeneigenes Referenzfahrzeug einzubauen und
          dessen Funktionsfähigkeit per Video zu dokumentieren. Für diese
          zusätzliche Dienstleistung wird ein gesondertes Arbeitsentgelt für den
          Mechatroniker berechnet. Eine telefonische technische Beratung oder
          Ferndiagnose gehört ausdrücklich nicht zum Leistungsumfang beim
          Verkauf von Ersatzteilen.
        </p>
        <p className={styles.infoPageText}>
          2b.&nbsp;
          <strong>
            Rücktrittsgebühr bei individuell programmierter Mechatronik:
          </strong>
          <br />
          Sollte der Kunde nach der Bestätigung unseres Angebots und dem Beginn
          der individuellen Programmierung des Mechatronik-Steuergeräts vom
          Vertrag zurücktreten wollen, behält sich die HIXA GmbH gemäß § 649 BGB
          (Kündigung des Werkvertrags) das Recht vor, eine Rücktrittsgebühr in
          Höhe von 30 % – 40 % des vereinbarten Gesamtpreises zu berechnen.
          <br />
          Diese Gebühr deckt die bereits erbrachten Arbeitsleistungen,
          insbesondere die Softwareprogrammierung, Kalibrierung und Vorbereitung
          des Steuergeräts, sowie die hierfür eingesetzten Materialien und
          Ressourcen.
          <br />
          Die Berechnung erfolgt unabhängig davon, ob das Steuergerät bereits
          ausgeliefert wurde oder sich noch im Produktionsprozess befindet.
          <br />
          Gemäß § 312g Abs. 2 Nr. 1 und Nr. 3 des Bürgerlichen Gesetzbuches
          (BGB) besteht kein Widerrufsrecht für Waren, die nach
          Kundenspezifikation angefertigt oder eindeutig auf die persönlichen
          Bedürfnisse des Kunden zugeschnitten sind, sowie für Waren, die
          aufgrund ihrer Beschaffenheit untrennbar mit anderen Gütern vermischt
          oder in ein Fahrzeug integriert wurden.
          <br />
          Damit wird klargestellt, dass individuell programmierte Mechatroniken
          und elektronische Steuergeräte, die nach Kundenvorgaben angepasst
          werden, vom Widerruf, Rückgaberecht und Umtausch ausgeschlossen sind.
        </p>

        <p className={styles.infoPageText}>
          3.&nbsp;<strong>Gebrauchte und instandgesetzte Teile:</strong>
          &nbsp;Teile, die bereits verwendet wurden und nach der Instandsetzung
          (Reparatur) nicht mehr im ursprünglichen Zustand sind, fallen nicht
          unter das allgemeine Widerrufsrecht.
        </p>
        <p className={styles.infoPageText}>
          Diese Ausschlüsse basieren auf den gesetzlichen Bestimmungen,
          insbesondere § 312g Abs. 2 BGB, wonach Waren, die nicht vorgefertigt
          sind und eindeutig auf die persönlichen Bedürfnisse des Verbrauchers
          zugeschnitten wurden, vom Widerrufsrecht ausgenommen sind.
        </p>
        <h2 className={styles.infoPageHeader}>
          Elektronische Steuergeräte und Mechatronik (z.B. Getriebe,
          Steuergeräte)
        </h2>
        <p className={styles.infoPageText}>
          1.&nbsp;<strong>Eigentumsübertragung nach Zahlung:</strong>
          &nbsp;Elektronische Steuergeräte, wie zum Beispiel Mechatroniken und
          Getriebe, an denen bereits eine kundenspezifische Programmierung (z.B.
          aufgespielte Software oder Datenübertragung) durchgeführt wurde, gehen
          nach vollständiger Zahlung in das Eigentum des Kunden über. Bis zur
          vollständigen Begleichung des Kaufpreises verbleibt das Eigentum an
          diesen Teilen bei HIXA GmbH .
        </p>
        <p className={styles.infoPageText}>
          2.&nbsp;<strong>Gebühren bei Rücktritt vom Vertrag:</strong>
          &nbsp;Sollte der Kunde nach bereits bestätigtem, sowohl mündlich als
          auch schriftlich, Angebot, nach erfolgter Programmierung oder
          Datenübertragung von dem Vertrag zurücktreten wollen, werden
          Rücktrittsgebühren in Höhe von 30-40% des Gesamtpreises berechnet, um
          die entstandenen Kosten für die durchgeführten Arbeiten abzudecken.
        </p>
        <h2 className={styles.infoPageHeader}>
          ALLGEMEINE GESCHÄFTSBEDINGUNGEN UND KUNDENINFORMATIONEN
        </h2>
        <p className="secure-policy__date">Aktualisiert: Oktober 2023</p>
        <p className={styles.infoPageText}>
          I. Allgemeine Geschäftsbedingungen
        </p>
        <p className={styles.infoPageText}>§ 1 Grundlegende Bestimmungen</p>
        <p className={styles.infoPageText}>
          (1) Die nachstehenden Geschäftsbedingungen gelten für Verträge, die
          Sie mit uns als Anbieter (HIXA GmbH ) über die Internetseite
          https://mehatronikdsg.de/ schließen. Soweit nicht anders vereinbart,
          wird der Einbeziehung gegebenenfalls von Ihnen verwendeter eigener
          Bedingungen widersprochen.
        </p>
        <p className={styles.infoPageText}>
          (2) Verbraucher im Sinne der nachstehenden Regelungen ist jede
          natürliche Person, die ein Rechtsgeschäft zu Zwecken abschließt, die
          überwiegend weder ihrer gewerblichen noch ihrer selbständigen
          beruflichen Tätigkeit zugerechnet werden kann. Unternehmer ist jede
          natürliche oder juristische Person oder eine rechtsfähige
          Personengesellschaft, die bei Abschluss eines Rechtsgeschäfts in
          Ausübung ihrer selbständigen beruflichen oder gewerblichen Tätigkeit
          handelt.
        </p>
        <p className={styles.infoPageText}>§ 2 Zustandekommen des Vertrages</p>
        <p className={styles.infoPageText}>
          (1) Gegenstand des Vertrages ist der Verkauf von Waren und / oder die
          Erbringung von Reparaturleistungen.
        </p>
        <p className={styles.infoPageText}>
          (2) Bereits mit dem Einstellen des jeweiligen Produkts auf unserer
          Internetseite unterbreiten wir Ihnen ein verbindliches Angebot zum
          Abschluss eines Vertrages über das Online-Warenkorbsystem zu den in
          der Artikelbeschreibung angegebenen Bedingungen.
        </p>
        <p className={styles.infoPageText}>
          (3) Der Vertrag kommt über das Online-Warenkorbsystem wie folgt
          zustande:
        </p>
        <p className={styles.infoPageText}>
          Die zum Kauf beabsichtigten Waren und / oder Reparaturleistungen
          werden im “Warenkorb” abgelegt. Über die entsprechende Schaltfläche in
          der Navigationsleiste können Sie den “Warenkorb” aufrufen und dort
          jederzeit Änderungen vornehmen.
        </p>
        <p className={styles.infoPageText}>
          Nach Aufrufen der Seite “Kasse” und der Eingabe der persönlichen Daten
          sowie der Zahlungs- und Versandbedingungen werden Ihnen abschließend
          die Bestelldaten als Bestellübersicht angezeigt.
        </p>
        <p className={styles.infoPageText}>
          Soweit Sie als Zahlungsart ein Sofortzahl-System (z.B. PayPal / PayPal
          Express, Amazon-Payments, Sofortüberweisung) nutzen, werden Sie
          entweder auf die Bestellübersichtsseite in unserem Online-Shop geführt
          oder auf die Internetseite des Anbieters des Sofortzahl-Systems
          weitergeleitet.
        </p>
        <p className={styles.infoPageText}>
          Erfolgt eine Weiterleitung zu dem jeweiligen Sofortzahl-System, nehmen
          Sie dort die entsprechende Auswahl bzw. Eingabe Ihrer Daten vor.
          Abschließend werden Ihnen auf der Internetseite des Anbieters des
          Sofortzahl-Systems oder nachdem Sie zurück in unseren Online-Shop
          geleitet wurden, die Bestelldaten als Bestellübersicht angezeigt.
        </p>
        <p className={styles.infoPageText}>
          Vor Absenden der Bestellung haben Sie die Möglichkeit, die Angaben in
          der Bestellübersicht nochmals zu überprüfen, zu ändern (auch über die
          Funktion “zurück” des Internetbrowsers) bzw. die Bestellung
          abzubrechen.
        </p>
        <p className={styles.infoPageText}>
          Mit dem Absenden der Bestellung über die entsprechende Schaltfläche
          (“zahlungspflichtig bestellen” oder ähnliche Bezeichnung) erklären Sie
          rechtsverbindlich die Annahme des Angebotes, wodurch der Vertrag
          zustande kommt.
        </p>
        <p className={styles.infoPageText}>
          (4) Ihre Anfragen zur Erstellung eines Angebotes sind für Sie
          unverbindlich. Wir unterbreiten Ihnen hierzu ein verbindliches Angebot
          in Textform (z.B. per E-Mail), welches Sie innerhalb von 5 Tagen
          (soweit im jeweiligen Angebot keine andere Frist ausgewiesen ist)
          annehmen können.
        </p>
        <p className={styles.infoPageText}>
          (5) Die Abwicklung der Bestellung und Übermittlung aller im
          Zusammenhang mit dem Vertragsschluss erforderlichen Informationen
          erfolgt per E-Mail zum Teil automatisiert. Sie haben deshalb
          sicherzustellen, dass die von Ihnen bei uns hinterlegte E-Mail-Adresse
          zutreffend ist, der Empfang der E-Mails technisch sichergestellt und
          insbesondere nicht durch SPAM-Filter verhindert wird.
        </p>
        <p className={styles.infoPageText}>
          § 3 Leistungserbringung bei Reparaturen
        </p>
        <p className={styles.infoPageText}>
          (1) Soweit Reparaturleistungen Vertragsgegenstand sind, schulden wir
          die sich aus der Leistungsbeschreibung ergebenden Reparaturarbeiten.
          Diese erbringen wir nach bestem Wissen und Gewissen persönlich oder
          durch Dritte.
        </p>
        <p className={styles.infoPageText}>
          (2) Sie sind zur Mitwirkung verpflichtet, insbesondere haben Sie den
          am Gerät bestehenden Defekt so umfassend als möglich zu beschreiben
          und das defekte Gerät zur Verfügung zu stellen.
        </p>
        <p className={styles.infoPageText}>
          (3) Sie tragen die Kosten für die Übersendung des defekten Gerätes an
          uns.
        </p>
        <p className={styles.infoPageText}>
          (4) Soweit im jeweiligen Angebot nichts anderes angegeben ist, erfolgt
          die Reparatur einschließlich Aufgabe des Gerätes zum Versand innerhalb
          von 5 – 7 Tagen nach Zugang des zu reparierenden Gerätes (bei
          vereinbarter Vorauszahlung jedoch erst nach dem Zeitpunkt Ihrer
          Zahlungsanweisung).
        </p>
        <p className={styles.infoPageText}>
          (5) Machen Sie von Ihrem Kündigungsrecht nach § 648 S. 1 BGB Gebrauch,
          können wir als pauschale Vergütung 10% der vereinbarten Vergütung
          verlangen, wenn die Ausführung noch nicht begonnen hat. Dies gilt bei
          Bestehen des gesetzlichen Widerrufsrechts jedoch nur, wenn Sie erst
          nach Ablauf der Widerrufsfrist von Ihrem Kündigungsrecht Gebrauch
          machen. Ihnen bleibt der Nachweis vorbehalten, dass uns tatsächlich
          keine oder wesentlich geringere Kosten entstanden sind.
        </p>
        <p className={styles.infoPageText}>
          § 4 Besondere Vereinbarungen zu angebotenen Zahlungsarten
        </p>
        <p className={styles.infoPageText}>(1) Zahlung über Klarna</p>
        <p className={styles.infoPageText}>
          In Zusammenarbeit mit Klarna Bank AB (publ)
          (https://www.klarna.com/de/), Sveavägen 46, 111 34 Stockholm,
          Schweden, bieten wir die folgenden Zahlungsoptionen an. Die Zahlung
          erfolgt jeweils an Klarna:
        </p>
        <p className={styles.infoPageText}>
          Sofortüberweisung: Verfügbar in Deutschland. Die Belastung Ihres
          Kontos erfolgt unmittelbar nach Abgabe der Bestellung.
        </p>
        <p className={styles.infoPageText}>
          Weitere Informationen und Klarnas Nutzungsbedingungen finden Sie hier
          (https://cdn.klarna.com/1.0/shared/content/legal/terms/0/de_de/user).
          Allgemeine Informationen zu Klarna erhalten Sie hier
          (https://www.klarna.com/de/). Ihre Personenangaben werden von Klarna
          in Übereinstimmung mit den geltenden Datenschutzbestimmungen und
          entsprechend den Angaben in Klarnas Datenschutzbestimmungen
          (https://cdn.klarna.com/1.0/shared/content/legal/terms/0/de_de/privacy)
          behandelt.
        </p>
        <p className={styles.infoPageText}>
          Weitere Informationen über Klarna finden Sie hier
          (https://www.klarna.com/de/smoooth-mehrzuklarna/). Die Klarna App
          finden Sie hier (https://www.klarna.com/de/klarna-app/).
        </p>
        <p className={styles.infoPageText}>
          § 5 Zurückbehaltungsrecht, Eigentumsvorbehalt
        </p>
        <p className={styles.infoPageText}>
          (1) Ein Zurückbehaltungsrecht können Sie nur ausüben, soweit es sich
          um Forderungen aus demselben Vertragsverhältnis handelt.
        </p>
        <p className={styles.infoPageText}>
          (2) Die Ware bleibt bis zur vollständigen Zahlung des Kaufpreises
          unser Eigentum.
        </p>
        <p className={styles.infoPageText}>§ 6 Gewährleistung</p>
        <p className={styles.infoPageText}>
          (1) Es bestehen die gesetzlichen Mängelhaftungsrechte.
        </p>
        <p className={styles.infoPageText}>
          (2) Bei gebrauchten Sachen sind die Mängelansprüche ausgeschlossen,
          wenn sich der Mangel erst nach Ablauf eines Jahres ab Ablieferung der
          Sache zeigt. Zeigt sich der Mangel innerhalb eines Jahres ab
          Ablieferung der Sache, können die Mängelansprüche im Rahmen der
          gesetzlichen Verjährungsfrist von zwei Jahren ab Ablieferung der Sache
          geltend gemacht werden. Die vorstehende Einschränkung gilt nicht:
        </p>
        <p className={styles.infoPageText}>
          - für uns zurechenbare schuldhaft verursachte Schäden aus der
          Verletzung des Lebens, des Körpers oder der Gesundheit und bei
          vorsätzlich oder grob fahrlässig verursachten sonstigen Schäden;
        </p>
        <p className={styles.infoPageText}>
          - soweit wir den Mangel arglistig verschwiegen oder eine Garantie für
          die Beschaffenheit der Sache übernommen haben.
        </p>
        <p className={styles.infoPageText}>
          (3) Als Verbraucher werden Sie gebeten, die Sache bei Lieferung
          umgehend auf Vollständigkeit, offensichtliche Mängel und
          Transportschäden zu überprüfen und uns sowie dem Spediteur
          Beanstandungen schnellstmöglich mitzuteilen. Kommen Sie dem nicht
          nach, hat dies keine Auswirkung auf Ihre gesetzlichen
          Gewährleistungsansprüche.
        </p>
        <p className={styles.infoPageText}>§ 7 Altteilrückgabe, Altteilpfand</p>
        <p className={styles.infoPageText}>
          (1) Soweit im konkreten Angebot ausgewiesen, wird zusätzlich zum
          Kaufpreis ein Altteilpfand erhoben. Die Höhe des Altteilpfandes ist im
          jeweiligen Angebot angegeben.
        </p>
        <p className={styles.infoPageText}>
          Das Altteilpfand ist zusammen mit dem Kaufpreis an uns zu zahlen, es
          sei denn Sie übereignen uns vor der Versendung der Kaufsache ein
          baugleiches Altteil, welches den Anforderungen gemäß Abs. 3 entspricht
          (in diesem Fall entfällt die Verpflichtung zur Zahlung des
          Altteilpfandes).
        </p>
        <p className={styles.infoPageText}>
          (2) Sie erhalten das Altteilpfand zurückerstattet, wenn Sie uns
          innerhalb von 7 Tagen nach Erhalt der Kaufsache ein baugleiches
          Altteil übereignen, welches den Anforderungen gemäß Abs. 3 entspricht.
          Die Rückerstattung erfolgt innerhalb von 30 Tagen nach Eingang des
          Altteils bei uns.
        </p>
        <p className={styles.infoPageText}>
          (3) Das von Ihnen zu übereignende baugleiche Altteil muss ein
          unbeschädigtes Gehäuse aufweisen, im Originalkarton übersandt werden
          und es dürfen keine originalen Bauteile fehlen. Andernfalls bleibt die
          Verpflichtung zur Zahlung des Altteilpfandes bestehen und Sie erhalten
          das übersandte Altteil zurück.
        </p>
        <p className={styles.infoPageText}>
          Sie tragen die Kosten und die Versandgefahr für die Übersendung des
          Altteils. Unfreie Sendungen werden von uns nicht angenommen.
        </p>
        <p className={styles.infoPageText}>§ 8 Rechtswahl</p>
        <p className={styles.infoPageText}>
          (1) Es gilt deutsches Recht. Bei Verbrauchern gilt diese Rechtswahl
          nur, soweit hierdurch der durch zwingende Bestimmungen des Rechts des
          Staates des gewöhnlichen Aufenthaltes des Verbrauchers gewährte Schutz
          nicht entzogen wird (Günstigkeitsprinzip).
        </p>
        <p className={styles.infoPageText}>
          (2) Die Bestimmungen des UN-Kaufrechts finden ausdrücklich keine
          Anwendung.
        </p>
        <p className={styles.infoPageText}></p>
        <p className={styles.infoPageText}>II. Kundeninformationen</p>
        <p className={styles.infoPageText}>1. Identität des Verkäufers</p>
        <p className={styles.infoPageText}>HIXA GmbH </p>
        <p className={styles.infoPageText}>Neukirchstraße 74, 13089 Berlin</p>
        <p className={styles.infoPageText}>
          vertr. d. d. Geschäftsführer Anna Likhnenko
        </p>
        <p className={styles.infoPageText}>Telefon: +49 30 520 151 91</p>
        <p className={styles.infoPageText}>E-Mail: kunden@hixa.eu</p>
        <p className={styles.infoPageText}></p>
        <p className={styles.infoPageText}>Alternative Streitbeilegung:</p>
        <p className={styles.infoPageText}>
          Die Europäische Kommission stellt eine Plattform für die
          außergerichtliche Online-Streitbeilegung (OS-Plattform) bereit,
          aufrufbar unter https://ec.europa.eu/odr (https://ec.europa.eu/odr).
        </p>
        <p className={styles.infoPageText}></p>
        <p className={styles.infoPageText}>
          2. Informationen zum Zustandekommen des Vertrages
        </p>
        <p className={styles.infoPageText}>
          Die technischen Schritte zum Vertragsschluss, der Vertragsschluss
          selbst und die Korrekturmöglichkeiten erfolgen nach Maßgabe der
          Regelungen “Zustandekommen des Vertrages” unserer Allgemeinen
          Geschäftsbedingungen (Teil I.).
        </p>
        <p className={styles.infoPageText}>
          3. Vertragssprache, Vertragstextspeicherung
        </p>
        <p className={styles.infoPageText}>3.1. Vertragssprache ist deutsch.</p>
        <p className={styles.infoPageText}>
          3.2. Der vollständige Vertragstext wird von uns nicht gespeichert. Vor
          Absenden der Bestellung über das Online – Warenkorbsystem können die
          Vertragsdaten über die Druckfunktion des Browsers ausgedruckt oder
          elektronisch gesichert werden. Nach Zugang der Bestellung bei uns
          werden die Bestelldaten, die gesetzlich vorgeschriebenen Informationen
          bei Fernabsatzverträgen und die Allgemeinen Geschäftsbedingungen
          nochmals per E-Mail an Sie übersandt.
        </p>
        <p className={styles.infoPageText}>
          3.3. Bei Angebotsanfragen außerhalb des Online-Warenkorbsystems
          erhalten Sie alle Vertragsdaten im Rahmen eines verbindlichen
          Angebotes in Textform übersandt, z.B. per E-Mail, welche Sie
          ausdrucken oder elektronisch sichern können.
        </p>
        <p className={styles.infoPageText}>
          4. Wesentliche Merkmale der Ware oder Dienstleistung
        </p>
        <p className={styles.infoPageText}>
          Die wesentlichen Merkmale der Ware und/oder Dienstleistung finden sich
          im jeweiligen Angebot.
        </p>
        <p className={styles.infoPageText}>5. Preise und Zahlungsmodalitäten</p>
        <p className={styles.infoPageText}>
          5.1. Die in den jeweiligen Angeboten angeführten Preise sowie die
          Versandkosten stellen Gesamtpreise dar. Sie beinhalten alle
          Preisbestandteile einschließlich aller anfallenden Steuern.
        </p>
        <p className={styles.infoPageText}>
          5.2. Die anfallenden Versandkosten sind nicht im Kaufpreis enthalten.
          Sie sind über eine entsprechend bezeichnete Schaltfläche auf unserer
          Internetpräsenz oder im jeweiligen Angebot aufrufbar, werden im Laufe
          des Bestellvorganges gesondert ausgewiesen und sind von Ihnen
          zusätzlich zu tragen, soweit nicht die versandkostenfreie Lieferung
          zugesagt ist.
        </p>
        <p className={styles.infoPageText}>
          5.3. Erfolgt die Lieferung in Länder außerhalb der Europäischen Union
          können von uns nicht zu vertretende weitere Kosten anfallen, wie z.B.
          Zölle, Steuern oder Geldübermittlungsgebühren (Überweisungs- oder
          Wechselkursgebühren der Kreditinstitute), die von Ihnen zu tragen
          sind.
        </p>
        <p className={styles.infoPageText}>
          5.4 Entstandene Kosten der Geldübermittlung (Überweisungs- oder
          Wechselkursgebühren der Kreditinstitute) sind von Ihnen in den Fällen
          zu tragen, in denen die Lieferung in einen EU-Mitgliedsstaat erfolgt,
          die Zahlung aber außerhalb der Europäischen Union veranlasst wurde.
        </p>
        <p className={styles.infoPageText}>
          5.5. Die Ihnen zur Verfügung stehenden Zahlungsarten sind unter einer
          entsprechend bezeichneten Schaltfläche auf unserer Internetpräsenz
          oder im jeweiligen Angebot ausgewiesen.
        </p>
        <p className={styles.infoPageText}>
          5.6. Soweit bei den einzelnen Zahlungsarten nicht anders angegeben,
          sind die Zahlungsansprüche aus dem geschlossenen Vertrag sofort zur
          Zahlung fällig.
        </p>
        <p className={styles.infoPageText}>6. Lieferbedingungen</p>
        <p className={styles.infoPageText}>
          6.1. Die Lieferbedingungen, der Liefertermin sowie gegebenenfalls
          bestehende Lieferbeschränkungen finden sich unter einer entsprechend
          bezeichneten Schaltfläche auf unserer Internetpräsenz oder im
          jeweiligen Angebot.
        </p>
        <p className={styles.infoPageText}>
          6.2. Soweit Sie Verbraucher sind ist gesetzlich geregelt, dass die
          Gefahr des zufälligen Untergangs und der zufälligen Verschlechterung
          der verkauften Sache während der Versendung erst mit der Übergabe der
          Ware an Sie übergeht, unabhängig davon, ob die Versendung versichert
          oder unversichert erfolgt. Dies gilt nicht, wenn Sie eigenständig ein
          nicht vom Unternehmer benanntes Transportunternehmen oder eine sonst
          zur Ausführung der Versendung bestimmte Person beauftragt haben.
        </p>
        <p className={styles.infoPageText}>
          7. Gesetzliches Mängelhaftungsrecht
        </p>
        <p className={styles.infoPageText}>
          Die Mängelhaftung richtet sich nach der Regelung “Gewährleistung” in
          unseren Allgemeinen Geschäftsbedingungen (Teil I).
        </p>
        <p className={styles.infoPageText}>8. Kündigung</p>
        <p className={styles.infoPageText}>
          8.1. Informationen zur Kündigung des Vertrages sowie den
          Kündigungsbedingungen finden Sie in den Regelungen zu
          “Reparaturleistungen” in unseren Allgemeinen Geschäftsbedingungen
          (Teil I), sowie im jeweiligen Angebot.
        </p>
        <p className={styles.infoPageText}>
          Diese AGB und Kundeninformationen wurden von den auf IT-Recht
          spezialisierten Juristen des Händlerbundes erstellt und werden
          permanent auf Rechtskonformität geprüft. Die Händlerbund Management AG
          garantiert für die Rechtssicherheit der Texte und haftet im Falle von
          Abmahnungen. Nähere Informationen dazu finden Sie unter:
          https://www.haendlerbund.de/de/leistungen/rechtssicherheit/agb-service
          (https://www.haendlerbund.de/de/leistungen/rechtssicherheit/agb-service).
        </p>
      </div>
      <CookiePopupButton></CookiePopupButton>
      <Footer></Footer>
    </div>
  );
};

export default AGB;
